export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12159.148a76e8.jpg";